<template>
  <a-modal :open="open" @cancel="false" :footer="false">
      <form @submit.prevent="updatePassword" class="password_form">
        <p class="password-change-header">Необходимо указать новый пароль</p>
        <div>
          <div class="password-field">
            <a-input v-model:value="form.password" :status="statusError.password ? 'error' : ''" type="password" />
            <span v-if="statusError.password">
              Пароль должен содержать минимум 8 символов
            </span>
          </div>
        </div>
        <div>
          <a-button class="primary-button" @click="updatePassword" :loading="modalActionLoading">
            Сохранить
          </a-button>
        </div>
      </form>
  </a-modal>
</template>

<script>
import CustomInput from "@/components/Forms/Fields/CustomInput.vue";
import {reactive} from "@vue/reactivity";
import {useStore} from "vuex";
import {ref} from "@vue/runtime-core";
import {message} from "ant-design-vue";

export default {
  name: "PopUpChangePassword",
  components: {CustomInput},
  props: {
    profile: {
      type: Object,
      required: true,
    },
    open: Boolean,
  },
  setup(props, context) {
    const store = useStore();
    const error = ref('');
    const statusError = reactive({
      password: false,
    });
    const modalActionLoading = ref(false);

    const form = reactive({
      password: null,
      reset_required: false,
      users: [props.profile.id],
    });

    const updatePassword = () =>  {
      statusError.password = false;
      modalActionLoading.value = true;

      if (form.password.length < 8) {
        statusError.password = true;
        modalActionLoading.value = false;
        return;
      }

      store.dispatch("users/resetStaffPassword", form)
          .then(() => {
            message.success('Данные обновлены');
            closeForm();
          })
          .finally(() => {
            modalActionLoading.value = false;
          });
    }

    const closeForm = () => {
      context.emit("close");
    }

    return {
      error,
      form,
      updatePassword,
      closeForm,
      statusError,
      modalActionLoading
    }
  }
}

</script>
<style scoped lang="scss">
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content {
  display: flex;
  padding: 10px;
  width: 40%;
  height: 300px;
  background-color: white;

  @media (max-width: 1024px) {
    width: 90%;
  }
}

.password_form {
  display: flex;
  margin: auto;
  flex-direction: column;
  row-gap: 15px;
}

div:has(.primary-button) {
  margin-left: auto;
}

.error_wrapper {
  margin-bottom: 10px;
  color: red;
  font-size: 14px;
  text-align: center;
  text-transform: lowercase;
}

.password-change-header {

}
</style>